import { apiRegistry } from '../../../common/infra/apiRegistry'
import { filesMem, generateId } from '../mem/filesMem'

apiRegistry.registerPostApi('uploadFile', async (request) => {
  const { file, parentId } = request

  // Validate parent exists
  if (parentId && !filesMem[parentId]) {
    throw new Error('Parent folder not found')
  }

  // Check for duplicate names
  const existingFiles = Object.values(filesMem).filter(f => f.parentId === parentId)
  if (existingFiles.some(f => f.name === file.name)) {
    throw new Error('A file with this name already exists')
  }

  const parentPath = parentId ? filesMem[parentId].path : ''
  const newId = generateId()
  const now = new Date().toISOString()
  const extension = file.name.split('.').pop()?.toLowerCase() || ''

  const uploadedFile = {
    id: newId,
    name: file.name,
    type: 'file' as const,
    size: file.size,
    modifiedDate: now,
    createdDate: now,
    parentId,
    path: `${parentPath}/${file.name}`,
    extension,
    mimeType: file.type,
    isStarred: false,
    isShared: false
  }

  filesMem[newId] = uploadedFile
  return { file: uploadedFile }
})